import React, { useEffect, useState } from 'react';
import styles from './hamburgerMenu.module.css';
import styless from '../navbar/navbar.module.css';
import { IoIosArrowDown } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAppearances, getGoldRate } from '../../../../redux/homeSlice';
import { setVisible } from '../../../../redux/authModelSlice';
import Goldrate from '../../Goldrate/Goldrate';

const HamburgerMenu = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { goldRateData, appearanceData } = useSelector((state) => state.appearances);
    const { subcategoriesByCategoryId } = useSelector((state) => state.products);
    const { isLoggedIn, user } = useSelector((state) => state.user);
    const categoriesData = appearanceData?.categories;

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isMobileView, setIsMobileView] = useState(false);
    const [activeCategory, setActiveCategory] = useState(null);

    useEffect(() => {
        const checkIfMobile = () => {
            setIsMobileView(window.innerWidth <= 896);
        };

        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);

    const closeMenu = () => {
        setIsMenuOpen(false);
        setActiveCategory(null);
    };

    const toggleMenu = () => {
        if (isMenuOpen) {
            closeMenu();
        } else {
            setIsMenuOpen(true);
        }
    };

    const handleCategoryInteraction = (categoryId) => {
        if (isMobileView) {
            setActiveCategory(activeCategory === categoryId ? null : categoryId);
        } else {
            setActiveCategory(categoryId);
        }
    };

    const handleCategoryLeave = () => {
        if (!isMobileView) {
            setActiveCategory(null);
        }
    };

    const handleWishlistClick = () => {
        if (!isLoggedIn) {
            dispatch(setVisible('signin'));
        } else {
            closeMenu();
            navigate('/wishlist');
        }
    };

    const handleCartClick = () => {
        if (!isLoggedIn) {
            dispatch(setVisible('signin'));
        } else {
            closeMenu();
            navigate('/cart');
        }
    };

    const handleGoldrateClick = () => {
        closeMenu();
        setIsPopupVisible(true);
    };

    const handleGoldrateClose = () => {
        setIsPopupVisible(false);
    };

    useEffect(() => {
        dispatch(getGoldRate())
    }, [dispatch])

    useEffect(() => {
        dispatch(getAppearances())
    }, [dispatch])

    return (
        <div className={styles.hamburgerContainer}>
            {/* Hamburger icon */}
            <div className={`${styles.hamburgerIcon} ${isMenuOpen ? styles.open : ''}`} onClick={toggleMenu}>
                <div className={styles.bar}></div>
                <div className={styles.bar}></div>
                <div className={styles.bar}></div>
            </div>

            {/* Navigation menu */}
            <nav className={`${styles.navMenu} ${isMenuOpen ? styles.open : ''}`}>
                <div className={styles.section2}>
                    <div className={styles.container2}>
                        <div className={styles.menu}>
                            <div className={styless.dropdownTrigger}
                                onClick={() => {
                                    navigate('/');
                                    closeMenu();
                                }}>HOME
                            </div>

                            {categoriesData?.map((category) => {
                                const subcategories = subcategoriesByCategoryId[category._id] || [];
                                return (
                                    <div key={category._id}
                                        className={styless.dropdownContainer}
                                        onMouseEnter={!isMobileView ? () => handleCategoryInteraction(category._id) : undefined}
                                        onMouseLeave={!isMobileView ? handleCategoryLeave : undefined}>
                                        <div
                                            className={styles.dropdownTrigger}
                                            onClick={() => {
                                                if (category?.subcategories?.length === 0 ||
                                                    (isMobileView && activeCategory !== category._id)) {
                                                    closeMenu();
                                                    navigate(`/product/${category?._id}`, { state: category?.name });
                                                } else if (isMobileView) {
                                                    handleCategoryInteraction(category._id);
                                                }
                                            }}
                                        >
                                            {category?.name} {category?.subcategories?.length > 0 && (
                                                <span
                                                    onClick={(e) => {
                                                        if (isMobileView) {
                                                            e.stopPropagation();
                                                            handleCategoryInteraction(category._id);
                                                        }
                                                    }}
                                                ><IoIosArrowDown className={styless.dropdownIcon} /></span>
                                            )}
                                        </div>

                                        {(activeCategory === category._id) && category?.subcategories?.length > 0 && (
                                            <div
                                                className={styless.dropdownMenu}
                                                onMouseEnter={!isMobileView ? () => handleCategoryInteraction(category._id) : undefined}
                                                onMouseLeave={!isMobileView ? handleCategoryLeave : undefined}
                                            >
                                                {category?.subcategories?.map((subCategory) => (
                                                    <div
                                                        key={subCategory._id}
                                                        className={styless.dropdownItem}
                                                        onClick={() => {
                                                            closeMenu();
                                                            navigate(`/productsWithSubCategory/${subCategory?._id}`, { state: category });
                                                        }}
                                                    >
                                                        {subCategory?.name}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )
                            })}

                            {/* WISHLIST */}
                            <div className={styless.dropdownTrigger}
                                onClick={handleWishlistClick}
                                style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                WISHLIST
                                {user?.unreadWishlistCount > 0 && (
                                    <span style={{
                                        background: 'red',
                                        color: 'white',
                                        fontSize: '11px',
                                        borderRadius: '50%',
                                        minWidth: '18px',
                                        minHeight: '18px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        padding: '2px',
                                        fontWeight: 'bold'
                                    }}>
                                        {user?.unreadWishlistCount}
                                    </span>
                                )}
                            </div>

                            {/* CART */}
                            <div className={styless.dropdownTrigger}
                                onClick={handleCartClick}
                                style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                CART
                                {user?.unreadCartCount > 0 && (
                                    <span style={{
                                        background: 'red',
                                        color: 'white',
                                        fontSize: '11px',
                                        borderRadius: '50%',
                                        minWidth: '18px',
                                        minHeight: '18px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        padding: '2px',
                                        fontWeight: 'bold'
                                    }}>
                                        {user?.unreadCartCount}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className={styless.timer} style={{ marginTop: '20px', marginLeft: '-32px', fontWeight: 700 }} onClick={handleGoldrateClick}>
                            <span>TODAY'S GOLD RATE</span>
                        </div>
                    </div>
                </div>
            </nav>
            {isPopupVisible && (
                <Goldrate onClose={handleGoldrateClose} goldRateData={goldRateData} />
            )}
        </div>
    );
};

export default HamburgerMenu;